import { uniqueId } from "lodash";
import { ExplorerResultFragmentFragment } from "types/graphql-schema";

import { getNodeUrl } from "@helpers/helpers";

import { getFlattenExplorerResult } from "./helpers";

export const getResultUniqueId = (result: ExplorerResultFragmentFragment) => {
  const flattenedResult = getFlattenExplorerResult(result) as any;
  if (flattenedResult?.id) {
    return `${result.__typename}-${flattenedResult.id}-${getNodeUrl(
      flattenedResult,
    )}`;
  }
  return uniqueId("explorer-content");
};
